/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Context from "../context/context";
import { v4 as uuidv4 } from "uuid";
import { openDB } from "idb";

const OrdersContent = ({ setOrderProps, scheduled, scheduleOrders }) => {
  const Navigate = useNavigate();
  const context = useContext(Context);
  const [selected_nonseat_orderID, setSelected_nonseat_orderID] = useState(sessionStorage.getItem('current-nonseat-order') || 0);

  const {
    forceRenderOrdersPage,
    itemChargesHandlerRef,
    itemChargesValueRef,
    selectMenu
  } = context;

  const [takeAwaysCollection, setTakeAwaysCollection] = useState(null);
  const [deliveriesCollection, setDeliveriesCollection] = useState(null);
  const IDBOrdersRef = useRef([]);
  const IDBPayModesRef = useRef([]);

  useEffect(() => {
    let DBOpenReq = indexedDB.open("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    DBOpenReq.addEventListener("error", (err) => { console.warn(err); });
    DBOpenReq.addEventListener("success", (ev) => {
      let db = ev.target.result;
      if (scheduled) {
        const unplaced_nonseat_orders = JSON.parse(localStorage.getItem("unplaced-nonseat-order")) || [];
        const takeAways = [];
        const deliveries = [];

        unplaced_nonseat_orders.forEach((i) => {
          i.isPlaced = false;
          i.id = i.order_uuid;
          if (+i.order_type === 1) {
            i.title = "TakeAway";
            takeAways.push(i);
          } else if (+i.order_type === 2) {
            i.title = "Delivery";
            deliveries.push(i);
          }
        });

        const ordersArray = [];
        console.log("scheduled", scheduleOrders);
        scheduleOrders?.forEach((o) => {
          if (+o.order_type === 1) {
            takeAways.push({
              id: o.order_uuid,
              created_at: o.created_at,
              title: o.local_order_id,
              amount: +o.order_total,
              isPlaced: true,
              order_status: +o.order_status,
              invoice_prints:
                o.invoice_prints && o.invoice_prints.length > 0 ? true : false,
            });
            ordersArray.push(o);
          } else if (+o.order_type === 2) {
            deliveries.push({
              id: o.order_uuid,
              created_at: o.created_at,
              title: o.local_order_id,
              amount: +o.order_total,
              isPlaced: true,
              order_status: +o.order_status,
              invoice_prints:
                o.invoice_prints && o.invoice_prints.length > 0 ? true : false,
            });
            ordersArray.push(o);
          }
        });

        IDBOrdersRef.current = ordersArray;

        // i.isPlaced = true;
        takeAways.sort((a, b) => b.created_at - a.created_at);
        deliveries.sort((a, b) => b.created_at - a.created_at);

        setTakeAwaysCollection(takeAways);
        setDeliveriesCollection(deliveries);

        let tx = db.transaction("payment_modes", "readonly");
        let store = tx.objectStore("payment_modes");
        let getPayModesReq = store.getAll();
        getPayModesReq.onsuccess = (reqEvent) => {
          IDBPayModesRef.current = reqEvent.target.result;
        };
      } else {
        let tx = db.transaction("running_orders", "readonly");
        let store = tx.objectStore("running_orders");

        let getReq = store.getAll();
        getReq.onsuccess = (ev) => {
          const unplaced_nonseat_orders = JSON.parse(localStorage.getItem("unplaced-nonseat-order") || '[]') || [];
          const takeAways = [];
          const deliveries = [];

          unplaced_nonseat_orders.forEach((i) => {
            i.isPlaced = false;
            i.id = i.order_uuid;
            if (+i.order_type === 1) {
              i.title = "TakeAway";
              takeAways.push(i);
            } else if (+i.order_type === 2) {
              i.title = "Delivery";
              deliveries.push(i);
            }
          });

          const ordersArray = [];

          ev.target.result.forEach((o) => {
            if (+o.order_type === 1) {
              takeAways.push({
                id: o.order_uuid,
                created_at: o.created_at,
                title: o.local_order_id,
                amount: +o.order_total,
                isPlaced: true,
                order_status: +o.order_status,
                accepted: +o.order_accepted === 1 ? true : false,
                invoice_prints:
                  o.invoice_prints && o.invoice_prints.length > 0
                    ? true
                    : false,
              });
              ordersArray.push(o);
            } else if (+o.order_type === 2) {
              deliveries.push({
                id: o.order_uuid,
                created_at: o.created_at,
                title: o.local_order_id,
                amount: +o.order_total,
                isPlaced: true,
                order_status: +o.order_status,
                accepted: +o.order_accepted === 1 ? true : false,
                invoice_prints:
                  o.invoice_prints && o.invoice_prints.length > 0
                    ? true
                    : false,
              });
              ordersArray.push(o);
            }
          });

          IDBOrdersRef.current = ordersArray;

          // i.isPlaced = true;
          takeAways.sort((a, b) => b.created_at - a.created_at);
          deliveries.sort((a, b) => b.created_at - a.created_at);

          setTakeAwaysCollection(takeAways);
          setDeliveriesCollection(deliveries);
        };

        tx = db.transaction("payment_modes", "readonly");
        store = tx.objectStore("payment_modes");
        let getPayModesReq = store.getAll();
        getPayModesReq.onsuccess = (reqEvent) => IDBPayModesRef.current = reqEvent.target.result;
      }

      let order_uuid = IDBOrdersRef.current?.length > 0 ? sessionStorage.getItem('nonseat-order-id') : null;
      if (!IDBOrdersRef.current?.find(i => i.order_uuid === order_uuid)) order_uuid = null;
      const query = order_uuid ? `[order_uuid="${order_uuid}"]` : '[index="0"]';
      const ivl = setInterval(() => {
        const element = document.querySelector(query);
        if (!element) return;
        clearInterval(ivl);

        let order_type = element?.getAttribute('type')?.toLowerCase();
        order_type = order_type === 'delivery' ? '2' : '1'

        const order_uuids = [order_uuid || uuidv4()]
        setOrderProps({
          order_uuids,
          order_uuid: order_uuids?.[0],
          order_type
        });
        setSelected_nonseat_orderID(order_uuid || +order_type);
        if (order_uuid) sessionStorage.setItem("nonseat-order-id", order_uuid);
      }, 100);
    });
  }, [forceRenderOrdersPage, scheduled, scheduleOrders]);

  let sectionIndex = -1;
  let elementIndex = -1;

  async function menuOpenHandler(id, type) {
    let menu_type;
    if (type.toLowerCase() === "takeaway") menu_type = "1";
    else if (type.toLowerCase() === "delivery") menu_type = "2";

    if (!menu_type) return console.warn("No valid menu-type passed");
    const order = IDBOrdersRef.current?.find(o => o.order_uuid === id)

    selectMenu({ brand_uuid: order?.brand_uuid || null }, menu_type, () => {
      itemChargesValueRef.current = [];
      itemChargesHandlerRef.current.click();

      if (id) sessionStorage.setItem("current-nonseat-order", id);
      else sessionStorage.removeItem("current-nonseat-order");

      sessionStorage.setItem("current-nonseat-type", type);
      Navigate(`/page2/${menu_type}/${id || uuidv4()}`);
    })
  }

  const singleClickHandler = (id, type) => {
    sessionStorage.setItem("current-nonseat-type", type === 1 ? "TakeAway" : type === 2 ? 'Delivery' : '');
    id ? sessionStorage.setItem("nonseat-order-id", id) : sessionStorage.removeItem("nonseat-order-id");
    const order_uuids = [id || uuidv4()]
    setOrderProps({
      order_uuids,
      order_uuid: order_uuids?.[0],
      order_type: `${type}`,
      lock_brands: id ? true : false
    })
    setSelected_nonseat_orderID(id || type);
  }

  const [warningPopUpReq, setWarningPopUpReq] = useState({
    status: false,
    id: null,
  });

  const [visibleContext, setVisibleContext] = useState(null);
  const cursorOverBtns = useRef(null);

  return (
    <div>
      <div className="sectionDiv">
        <h1>TakeAway</h1>
        <div
          className="content"
          id="orders_container"
          this-section-index={++sectionIndex}
        >
          <div
            index={++elementIndex}
            section-index={sectionIndex}
            className="order-card-div"
            onClick={(e) => singleClickHandler(null, 1)}
            onDoubleClick={() => menuOpenHandler(null, "TakeAway")}
          >
            <div
              className="order-click-handler"
              style={{ display: "none" }}
              onClick={() => menuOpenHandler(null, "TakeAway")}
            />
            <button
              id="takeaway-add-btn"
              className={`card-focus rounded ${selected_nonseat_orderID === 1 ||
                selected_nonseat_orderID === "takeaway-add-btn"
                ? "highlighted-card"
                : ""
                }`}
            >
              <div className={`card rounded`}>
                <p className="title2"> + TakeAway</p>
                <p className="caption"></p>
                <div
                  className={`horizontal-line`}
                  style={{ background: `#44cd4a` }}
                ></div>
              </div>
            </button>
          </div>
          {takeAwaysCollection?.map((takeaway) => {
            let color;
            const nonSeats_ExtendedOrders = JSON.parse(localStorage.getItem("extended-nonseat-order")) || [];
            let isExtended = nonSeats_ExtendedOrders.find((o) => o.order_uuid === takeaway.id);
            if (isExtended || !takeaway.isPlaced) color = "blue";
            else if (takeaway.invoice_prints) color = "yellow";
            else if (takeaway.isPlaced) color = "red";

            return (
              <div
                key={Math.random()}
                index={++elementIndex}
                section-index={sectionIndex}
                className="order-card-div"
                onClick={e => {
                  if (cursorOverBtns.current) return;
                  singleClickHandler(takeaway.id, 1)
                }}
                onMouseDown={(e) => {
                  e.preventDefault();
                  if (cursorOverBtns.current) return;
                  if (e.detail > 1 && +takeaway.order_status !== 0) menuOpenHandler(takeaway.id, 'TakeAway')
                  else singleClickHandler(takeaway.id, 1)
                }}
              >
                <Card
                  type={"TakeAway"}
                  title={takeaway.title}
                  order={takeaway}
                  isPlaced={takeaway.isPlaced}
                  hLineColor={color}
                  menuOpenHandler={menuOpenHandler}
                  selected_nonseat_orderID={selected_nonseat_orderID}
                  setSelected_nonseat_orderID={setSelected_nonseat_orderID}
                  setWarningPopUpReq={setWarningPopUpReq}
                  visibleContext={visibleContext}
                  setVisibleContext={setVisibleContext}
                  payModes={IDBPayModesRef.current}
                  cursorOverBtns={cursorOverBtns}
                  updateOrderState={setTakeAwaysCollection}
                />
              </div>
            );
          })}
        </div>
      </div>
      <div className="sectionDiv">
        <h1>Delivery</h1>
        <div className="content" this-section-index={++sectionIndex}>
          <div
            index={++elementIndex}
            section-index={sectionIndex}
            className="order-card-div"
            onClick={(e) => singleClickHandler(null, 2)}
            onDoubleClick={() => menuOpenHandler(null, "Delivery")}
          >
            <div
              className="order-click-handler"
              style={{ display: "none" }}
              onClick={() => menuOpenHandler(null, "Delivery")}
            />
            <button
              id="delivery-add-btn"
              className={`card-focus rounded ${selected_nonseat_orderID === 2 ||
                selected_nonseat_orderID === "delivery-add-btn"
                ? "highlighted-card"
                : ""
                }`}
            >
              <div className={`card rounded`}>
                <p className="title2"> + Delivery</p>
                <p className="caption"></p>
                <div
                  className={`horizontal-line`}
                  style={{ background: `#44cd4a` }}
                ></div>
              </div>
            </button>
          </div>

          {deliveriesCollection?.map((delivery) => {
            let color;
            const nonSeats_ExtendedOrders = JSON.parse(localStorage.getItem("extended-nonseat-order")) || [];
            let isExtended = nonSeats_ExtendedOrders.find((o) => o.order_uuid === delivery.id);
            if (isExtended || !delivery.isPlaced) color = "blue";
            else if (delivery.invoice_prints) color = "yellow";
            else if (delivery.isPlaced) color = "red";

            return (
              <div
                key={Math.random()}
                index={++elementIndex}
                section-index={sectionIndex}
                className="order-card-div"
                onClick={e => {
                  if (cursorOverBtns.current) return;
                  singleClickHandler(delivery.id, 2);
                }}
                onMouseDown={e => {
                  e.preventDefault();
                  if (cursorOverBtns.current) return;
                  if (e.detail > 1 && +delivery.order_status !== 0) menuOpenHandler(delivery.id, 'Delivery')
                  else singleClickHandler(delivery.id, 2);
                }}
              >
                <Card
                  type={"Delivery"}
                  title={delivery.title}
                  order={delivery}
                  isPlaced={delivery.isPlaced}
                  hLineColor={color}
                  menuOpenHandler={menuOpenHandler}
                  selected_nonseat_orderID={selected_nonseat_orderID}
                  setSelected_nonseat_orderID={setSelected_nonseat_orderID}
                  setWarningPopUpReq={setWarningPopUpReq}
                  visibleContext={visibleContext}
                  setVisibleContext={setVisibleContext}
                  payModes={IDBPayModesRef.current}
                  cursorOverBtns={cursorOverBtns}
                  updateOrderState={setDeliveriesCollection}
                />
              </div>
            );
          })}
        </div>
      </div>
      {warningPopUpReq.status && (
        <ReqDeclineWarning
          warningPopUpReq={warningPopUpReq}
          setWarningPopUpReq={setWarningPopUpReq}
        />
      )}
    </div>
  );
};

function Card({
  title,
  order,
  isPlaced,
  type,
  hLineColor,
  menuOpenHandler,
  setWarningPopUpReq,
  selected_nonseat_orderID,
  setSelected_nonseat_orderID,
  visibleContext,
  setVisibleContext,
  payModes,
  cursorOverBtns,
  updateOrderState
}) {
  const context = useContext(Context);
  const { setForceRenderOrdersPage, toggleAlarm, updateUnSync, PrintKotInvoice, applyChargesDiscounts } = context;
  let timeGap = isPlaced ? Date.now() - order.created_at : 0;
  let timeGapStr = new Date(timeGap).toUTCString().slice(17, -7);
  const [time, setTime] = useState(timeGapStr);
  const [acceptButtonPrevent, setAcceptButtonPrevent] = useState(false)

  useEffect(() => {
    isPlaced &&
      setInterval(() => {
        let time_gap = Date.now() - order.created_at;
        time_gap = new Date(time_gap).toUTCString().slice(17, -7);
        setTime(time_gap);
      }, 60000);
  }, []);

  const printKotInvoice = async (kotNumber, order_json) => {

    if (!order_json) return console.log('No order found to print');
    let db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const outlet = await (db.transaction("outlet", "readonly").objectStore("outlet")).get(localStorage.getItem('outlet_uuid'));
    const user = order_json?.payment_by_user_uuid && await (db.transaction("user", "readonly").objectStore("user")).get(order_json?.payment_by_user_uuid);
    const seat = order_json?.seat_uuid && await (db.transaction("seats", "readonly").objectStore("seats")).get(order_json?.seat_uuid);
    const paymentMode = await (db.transaction("payment_modes", "readonly").objectStore("payment_modes")).getAll();
    const categoryDetails = await (db.transaction("category", "readonly").objectStore("category")).getAll();
    const itemsDetails = await (db.transaction("item", "readonly").objectStore("item")).getAll();
    const item_groups = await (db.transaction("item_grouping", "readonly").objectStore("item_grouping")).getAll();

    PrintKotInvoice({
      dependencies: {
        user_title: user?.user_title,
        order_json,
        paymentMode,
        categoryDetails,
        kot_setup: outlet?.kot_setup,
        kotNumber,
        section_name: seat && outlet?.section_details?.find(i => i.section_uuid === seat?.section_uuid)?.section_name,
        seat_name: seat?.seat_name,
        itemsDetails,
      },
      item_groups,
      // callback: () => setShowKots(false)
    })
  };

  const checkAlarmConditon = () => {
    let order_requests = JSON.parse(localStorage.getItem("order_requests"));
    order_requests = order_requests.filter((r) => r !== order.id);
    localStorage.setItem("order_requests", JSON.stringify(order_requests));
    if (order_requests.length === 0) {
      console.log("all requests processed!!");
      toggleAlarm(false);
    }
  }

  async function completeOrderReq() {
    checkAlarmConditon()
    let db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    let store = db.transaction("running_orders", "readwrite").objectStore("running_orders");
    let json = await store.get(order.id);
    if (json) {
      json.order_status = 4;
      await store.delete(json?.IDENTIFIER);

      delete json.IsSynched;
      delete json.Sync_Type;
      await db.transaction("Orders", "readwrite").objectStore("Orders").add(json);
      await db.transaction("unsynced_files", "readwrite").objectStore("unsynced_files").add({ ...json, BACKUP: 0, IDENTIFIER: `order-new:${json.order_uuid}` });
      setForceRenderOrdersPage(uuidv4() + uuidv4())
      updateUnSync()
    }
  }

  function acceptOrderReq() {
    let DBOpenReq = indexedDB.open("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    DBOpenReq.onerror = (err) => console.warn(err);
    DBOpenReq.onsuccess = (ev) => {
      let store = ev.target.result.transaction("running_orders", "readwrite").objectStore("running_orders");
      let getOrder = store.get(order.id);
      getOrder.onsuccess = (orderEvent) => {
        let json = orderEvent.target.result;
        if (!json) return console.log("no json found in indexeddb");

        sessionStorage.setItem("current-nonseat-type", type);
        setSelected_nonseat_orderID(order.id);

        json.IsSynched = 0;
        const kot_type = +sessionStorage.getItem("kot_type");

        json.preparation_status = kot_type === 1 ? 0 : 1;
        for (const kot of json.order_kot_details) {
          for (const item of kot.kot_items_details) {
            item.order_item_status = kot_type === 1 ? "0" : "1";
          }
          kot.kot_status = kot_type === 1 ? "0" : "1";
        }

        if (json?.charges_and_discounts?.[0]) {
          for (const obj of json?.charges_and_discounts) {
            const response = applyChargesDiscounts({ obj, order: json })
            json = response.order
          }
        }

        if (+json.preparation_status === 1 && +json.payment_status === 1) {
          json.order_accepted = 1
          store.put(json);
          return updateOrderState(curr => curr.map(i => i.id === order.id ? ({ ...i, accepted: true }) : i))
        }

        json.order_status = "3";
        store.put(json);
        console.log("json accepted update", json);
        cursorOverBtns.current = null;
        checkAlarmConditon()
        setForceRenderOrdersPage(uuidv4() + uuidv4());
        if (+kot_type === 2) printKotInvoice(+json.order_kot_details?.at(-1)?.kot, json)
      };
    };
  }

  function declineOrderReq() {
    let DBOpenReq = indexedDB.open("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    console.log("idb collection opened on", window.location.pathname);
    DBOpenReq.onerror = (err) => console.warn(err);
    DBOpenReq.onsuccess = (ev) => {
      let store = ev.target.result.transaction("running_orders", "readwrite").objectStore("running_orders"); let getOrder = store.get(order.id);
      getOrder.onsuccess = (orderEvent) => {
        let order = orderEvent.target.result;
        if (!order) return console.log("no order found in indexeddb");

        store.delete(order.order_uuid);
        setWarningPopUpReq({ status: false, id: null });
        setForceRenderOrdersPage(uuidv4() + uuidv4());

        delete order.IsSynched;

        order.order_kot_details.forEach((kot) => {
          kot.kot_gst = 0;
          kot.kot_total = 0;
          kot.kot_vat = 0;
          kot.kot_status = '2'

          kot.kot_items_details?.forEach((item) => {
            item.order_item_status = "2";
          });
        });

        order.order_status = 4;
        order.order_total = 0;
        order.total_tax_gst = 0;
        order.total_tax_vat = 0;

        order.payment_details = (order?.payment_details?.filter(i => i.payment_mode_uuid === 'UPI') || [])
          .concat([
            {
              payment_mode_uuid: payModes.find((p) => p.primary_cash === "Y")
                ?.payment_mode_uuid,
              amount: 0,
            }
          ]);

        order.payment_status = "1";
        order.payment_total = 0;
        order.preparation_status = "1";

        order.completed_at = Date.now();
        order.payment_at = Date.now();
        order.payment_by_user_uuid = localStorage.getItem("user_uuid");

        store = ev.target.result.transaction("Orders", "readwrite").objectStore("Orders");
        store.add(order);

        store = ev.target.result.transaction("unsynced_files", "readwrite").objectStore("unsynced_files");
        order.IDENTIFIER = "order-new:" + order.order_uuid;
        order.BACKUP = 0;
        store.add(order);

        console.log("order accepted update", order);

        let order_requests = JSON.parse(localStorage.getItem("order_requests"));
        order_requests = order_requests.filter((r) => r !== order.order_uuid);
        localStorage.setItem("order_requests", JSON.stringify(order_requests));

        if (order_requests.length === 0) {
          console.log("all requests processed!!");
          toggleAlarm(false);
        }
        setTimeout(() => updateUnSync(), 2000);
      };
    };
  }

  return (
    <>
      <div
        className="order-click-handler"
        style={{ display: "none" }}
        onClick={() => menuOpenHandler(order.id, type)}
      />
      <button
        id={order.id}
        type={type}
        order_uuid={order.id}
        className={`card-focus rounded ${selected_nonseat_orderID === order.id && "highlighted-card"}`}
      >
        <div className={`card rounded`}>
          <p className="title2">{title}</p>
          <p className="caption">{isPlaced ? type : ""}</p>
          {+order.order_status !== 0 ? (
            <>
              <div
                className={`horizontal-line`}
                style={{ background: hLineColor || "transparent" }}
              ></div>
              {isPlaced && (
                <div className="seatTimer">
                  <div>{time}</div>
                  <div>(Rs.{order.amount})</div>
                </div>
              )}
            </>
          ) : (
            <div
              className="order-request-prompt"
              onMouseEnter={(e) => {
                cursorOverBtns.current = true;
              }}
              onMouseLeave={(e) => {
                cursorOverBtns.current = null;
              }}
            >
              <div className="btns">
                {order?.accepted ? (
                  <button id="complete" onClick={completeOrderReq}>
                    Complete
                  </button>
                ) : !acceptButtonPrevent ? (
                  <>
                    <button
                      id="reject"
                      onClick={e => {
                        e.target.style.display = 'none'
                        setAcceptButtonPrevent(true)
                        cursorOverBtns.current = null;
                        setWarningPopUpReq({
                          status: true,
                          id: null,
                          callback: declineOrderReq,
                        });
                      }}
                    >
                      Decline
                    </button>
                    <button id="accept" onClick={acceptOrderReq}>
                      Accept
                    </button>
                  </>
                ) : ''}
              </div>
            </div>
          )}
        </div>
      </button>
      {/* {visibleContext === order.id && <ContextMenu
                id={order.id}
                setVisibleContext={setVisibleContext}
                order_type={type === "TakeAway" ? 1 : type === "Delivery" && 2}
            />
            } */}
    </>
  );
}

const ReqDeclineWarning = ({ warningPopUpReq, setWarningPopUpReq }) => {
  return (
    <>
      <div id="req-decline-warning-popup">
        <div>
          <p>Are you sure, you want to decline this order request?</p>
          <div className="btns">
            <button
              id="reject"
              onClick={() => setWarningPopUpReq({ status: false, id: null })}
            >
              Cancel
            </button>
            <button
              id="accept"
              onClick={() => {
                warningPopUpReq?.callback();
              }}
            >
              Yes
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrdersContent;